import React, { Component } from "react";
import { CRUDFunction } from "../../reduxCURD/container";
import { curdActions } from "../../reduxCURD/actions";
import { getInspectionTree, getInspectionSummary } from "./utils/getInspectionTree";
import InspectionPlanCard from "./components/InspectionPlanCard";
import { STATUS_TEXT_COLORS, STATUS_BACKGROUND_COLORS } from "./statusColors";
import "./styles.css";
import { CardTypeThree } from "../Common/Cards";
import MenuFilter from "components/Common/MenuFilters/index";
import PropagateLoader from "react-spinners/PropagateLoader";
import { themeService } from "../../theme/service/activeTheme.service";
import SpinnerLoader from "components/Common/SpinnerLoader";
class InspectionSchedule extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workPlanTemplates: [],
      inspectionTree: [],
      baseInspectionTree: [],
      inspectionSummary: { totalPlans: 0, overdue: 0, expiring: 0, due: 0, upcoming: 0 },
      expandedPlans: {}, // Track which plans are expanded
      assetTypesToDisplay: [],
      searchText: "",
      selectedStatus: "",
      filterLocations: null,
      spinnerLoading: false,
    };
    this.filterLocations = this.filterLocations.bind(this);
    this.buildInspectionTree = this.buildInspectionTree.bind(this);
  }
  componentDidMount() {
    const { getAssetType } = this.props;

    getAssetType && getAssetType();
  }
  componentDidUpdate(prevProps) {
    const { workPlanTemplateActionType, workPlanTemplates, assetTypeActionType, assetTypes, getWorkPlanTemplates } = this.props;
    if (
      (prevProps.workPlanTemplateActionType !== workPlanTemplateActionType &&
        workPlanTemplateActionType === "WORKPLANTEMPLATES_READ_REQUEST") ||
      (prevProps.assetTypeActionType !== assetTypeActionType && assetTypeActionType === "ASSETTYPES_READ_REQUEST")
    ) {
      this.setState({ spinnerLoading: true });
    }
    if (
      (prevProps.workPlanTemplateActionType !== workPlanTemplateActionType &&
        workPlanTemplateActionType === "WORKPLANTEMPLATES_READ_FAILURE") ||
      (prevProps.assetTypeActionType !== assetTypeActionType && assetTypeActionType === "ASSETTYPES_READ_FAILURE")
    ) {
      this.setState({ spinnerLoading: false });
    }
    if (
      prevProps.workPlanTemplateActionType !== workPlanTemplateActionType &&
      workPlanTemplateActionType === "WORKPLANTEMPLATES_READ_SUCCESS"
    ) {
      this.setState({ workPlanTemplates: workPlanTemplates || [], spinnerLoading: false }, () => {
        this.buildInspectionTree({ workPlanTemplates: workPlanTemplates || [] });
      });
    }
    if (prevProps.assetTypeActionType !== assetTypeActionType && assetTypeActionType === "ASSETTYPES_READ_SUCCESS") {
      let valid = assetTypes.filter((at) => at.inspectable === true && at.configurationAsset === false);
      const assetTypesToDisplay = valid.map((a) => a.assetType);
      this.setState({ assetTypesToDisplay, spinnerLoading: false }, () => {
        if (this.state.workPlanTemplates && this.state.workPlanTemplates.length > 0) {
          this.buildInspectionTree({ assetTypesToDisplay });
        } else {
          getWorkPlanTemplates && getWorkPlanTemplates();
        }
      });
    }
  }

  filterWorkPlanTemplates = (workPlanTemplates = [], searchText = "") => {
    const trimmedSearch = String(searchText || "")
      .trim()
      .toLowerCase();
    if (!trimmedSearch) return workPlanTemplates;

    return workPlanTemplates.filter((plan) => {
      const title = String(plan.title || plan.name || "").toLowerCase();
      const planId = String(plan.id || plan._id || plan.workplanTemplateId || "").toLowerCase();
      return title.includes(trimmedSearch) || planId.includes(trimmedSearch);
    });
  };

  buildInspectionTree = ({ workPlanTemplates, searchText, selectedStatus, assetTypesToDisplay, filterLocations } = {}) => {
    const nextSearchText = searchText !== undefined ? searchText : this.state.searchText;
    const nextSelectedStatus = selectedStatus !== undefined ? selectedStatus : this.state.selectedStatus || "";
    let nextWorkPlanTemplates = workPlanTemplates !== undefined ? workPlanTemplates : this.state.workPlanTemplates;
    const nextAssetTypesToDisplay = assetTypesToDisplay !== undefined ? assetTypesToDisplay : this.state.assetTypesToDisplay;
    const nextFilterLocations = filterLocations || this.state.filterLocations;
    if (filterLocations && Array.isArray(nextFilterLocations) && nextFilterLocations.length > 0) {
      const allowedLocationIds = new Set(nextFilterLocations.map((id) => String(id).trim()));
      nextWorkPlanTemplates = nextWorkPlanTemplates.filter((plan) => {
        return allowedLocationIds.has((plan.lineId || "").trim());
      });
    }
    const filteredTemplates = this.filterWorkPlanTemplates(nextWorkPlanTemplates, nextSearchText);
    let baseInspectionTree = getInspectionTree(filteredTemplates, nextAssetTypesToDisplay);

    const inspectionSummary = getInspectionSummary(baseInspectionTree);
    const normalizedStatus = String(nextSelectedStatus || "").toLowerCase();
    const inspectionTree = normalizedStatus
      ? baseInspectionTree.filter((plan) => String(plan.status || "").toLowerCase() === normalizedStatus)
      : baseInspectionTree;
    this.setState({
      inspectionTree,
      inspectionSummary,
      baseInspectionTree,
      searchText: nextSearchText,
      selectedStatus: normalizedStatus,
      filterLocations: nextFilterLocations,
    });
  };

  handleSearchTextChange = (event) => {
    this.buildInspectionTree({ searchText: event.target.value || "" });
  };

  handleSummaryCardClick = (statusKey) => {
    const normalizedKey = statusKey === "all" ? "" : statusKey;
    const nextSelectedStatus = this.state.selectedStatus === normalizedKey ? "" : normalizedKey;
    this.buildInspectionTree({ selectedStatus: nextSelectedStatus });
  };

  togglePlanExpanded = (planId) => {
    this.setState((prevState) => ({
      expandedPlans: {
        ...prevState.expandedPlans,
        [planId]: !prevState.expandedPlans[planId],
      },
    }));
  };

  getPlanSummary = (plan) => {
    if (!plan || !plan.children || plan.children.length === 0) {
      return { overdue: 0, expiring: 0, due: 0, upcoming: 0 };
    }

    const summary = { overdue: 0, expiring: 0, due: 0, upcoming: 0 };

    plan.children.forEach((asset) => {
      const allTests = [
        ...(asset.unGroupedChildren || []),
        ...((asset.groupedChildren && asset.groupedChildren.flatMap((group) => group.tests)) || []),
      ];
      allTests.forEach((test) => {
        if (test.status && summary.hasOwnProperty(test.status)) {
          summary[test.status]++;
        }
      });
    });

    return summary;
  };
  filterLocations(locations) {
    const filtered = locations.filter((loc) => loc.state).map((loc) => loc.id);
    this.setState({ filterLocations: filtered }, () => {
      this.buildInspectionTree({ filterLocations: filtered });
    });
  }
  render() {
    const { inspectionSummary, inspectionTree, expandedPlans, baseInspectionTree, selectedStatus, spinnerLoading } = this.state;
    const showFilterMessage = this.state.searchText.trim() || selectedStatus;
    const selectedLabel = selectedStatus ? `Filtered by ${selectedStatus}` : "";
    let modelRendered = <SpinnerLoader spinnerLoading={spinnerLoading} />;
    return (
      <div className="mainContent" style={{ padding: "20px", margin: "0 auto" }}>
        {modelRendered}
        <MenuFilter
          menuFilterApplied={(assetChildren, options) => {
            this.filterLocations(assetChildren);
          }}
          handelMenuClickData={(assetChildren, displayMenuAll, lineNames) => {
            this.filterLocations(assetChildren);
          }}
          displayMenuAll={true}
          dataLoadedCallback={() => {}}
        />
        {/* Overall Summary Header */}
        <div style={{ marginBlock: "30px" }}>
          <h1 style={{ margin: "0 0 20px 0", fontSize: "24px", fontWeight: "700" }}>Inspection Schedule</h1>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
              gap: "12px",
            }}
          >
            {[
              { key: "all", text: "Total Plans", number: inspectionSummary.totalPlans },
              { key: "overdue", text: "Overdue", number: inspectionSummary.overdue, color: STATUS_TEXT_COLORS.overdue },
              { key: "expiring", text: "Expiring", number: inspectionSummary.expiring, color: STATUS_TEXT_COLORS.expiring },
              { key: "due", text: "Available", number: inspectionSummary.due, color: STATUS_TEXT_COLORS.due },
              { key: "upcoming", text: "Upcoming", number: inspectionSummary.upcoming, color: STATUS_TEXT_COLORS.upcoming },
            ].map((card) => {
              return (
                <div key={card.key} role="button" onClick={() => this.handleSummaryCardClick(card.key)}>
                  <CardTypeThree text={card.text} numberColor={card.color} number={card.number} />
                </div>
              );
            })}
          </div>
          <div style={{ margin: "24px 0 0 0", maxWidth: "420px" }}>
            <input
              type="text"
              value={this.state.searchText}
              onChange={this.handleSearchTextChange}
              placeholder="Search work plan templates"
              style={{
                width: "100%",
                padding: "10px 12px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                fontSize: "14px",
                outline: "none",
              }}
            />
          </div>
          {showFilterMessage ? (
            <div style={{ marginTop: "12px", color: "#333", fontSize: "14px" }}>
              {selectedLabel && <span>{selectedLabel}. </span>}
              Showing {inspectionTree.length} of {baseInspectionTree.length} template{baseInspectionTree.length === 1 ? "" : "s"}
            </div>
          ) : null}
        </div>

        {/* Plans List */}
        {inspectionTree.length === 0 ? (
          <div
            style={{
              padding: "40px 20px",
              textAlign: "center",
              color: "#666",
              backgroundColor: "white",
              borderRadius: "8px",
            }}
          >
            <p style={{ margin: "0", fontSize: "16px" }}>No inspection plans available yet.</p>
          </div>
        ) : (
          <div className="inspection-plan-grid">
            {inspectionTree.map((plan) => (
              <InspectionPlanCard key={plan.id} plan={plan} planSummary={this.getPlanSummary(plan)} />
            ))}
          </div>
        )}
      </div>
    );
  }
}
const getWorkPlanTemplates = curdActions.getWorkPlanTemplates;
const getAssetType = curdActions.getAssetType;
const actionOptions = {
  create: false,
  update: false,
  read: false,
  delete: false,
  others: {
    getWorkPlanTemplates,
    getAssetType,
  },
};
const InspectionScheduleContainer = CRUDFunction(
  InspectionSchedule,
  "InspectionSchedule",
  actionOptions,
  {
    workPlanTemplateReducer: {
      workPlanTemplates: [],
    },
    assetTypeReducer: {
      assetTypes: [],
    },
  },
  ["workPlanTemplateReducer", "assetTypeReducer"],
);
export default InspectionScheduleContainer;



// WEBPACK FOOTER //
// ./src/components/InspectionSchedule/index.jsx